import React from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import DataTable from "../../../../components/DataTable";
import { ALL_WORK_ORDER_PARTS_VIEW_QUERY } from "../../../../graphql/WorkOrders/WorkOrderParts.graphql";
import { WORK_ORDER_PARTS_VIEW_COLUMNS } from "../columns";

function PartsHistory({ filters, Auth }) {
  const { id } = useParams();
  return (
    <React.Fragment>
      <DataTable
        columns={WORK_ORDER_PARTS_VIEW_COLUMNS(Auth)}
        dataQuery={ALL_WORK_ORDER_PARTS_VIEW_QUERY}
        initialSortBy={[
          { id: "CompletedDate", desc: true },
          { id: "WONumber", desc: false },
          { id: "LineNo", desc: false }
        ]}
        name="VW_WorkOrderPart"
        where={{ ...filters, VehicleRecIdRef: parseInt(id) }}
      />
    </React.Fragment>
  );
}
PartsHistory.propTypes = {
  filters: PropTypes.object,
  Auth: PropTypes.bool
};
export default PartsHistory;
